import * as React from 'react';
export const IcLandPreparation = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.45 13.28c-.28-.14-1.89-.78-5.82.79-1.7.68-2.46 0-3.88-1.59S7.4 8.81 3.68 10.05A1 1 0 003 11v9a1 1 0 001 1h16a1 1 0 001-1v-5.83a1 1 0 00-.55-.89zM14 12h1.17a3 3 0 002.12-.88l2.42-2.41a1 1 0 000-1.42l-.8-.79 1.8-1.79a1.004 1.004 0 10-1.42-1.42l-1.79 1.8-.79-.8a1 1 0 00-1.42 0l-2.41 2.42A3 3 0 0012 8.83V10a2 2 0 002 2z'
      fill='currentColor'
    />
  </svg>
);
